// Member offboarding (backend: zofino-strapi src/api/workspace-offboarding): before a member is removed,
// each current responsibility gets a decision — transfer to another active member, unassign, or detach.

export const offboardingSteps = (impact) => (
    impact?.total > 0 ? ["impact", "transfer", "review"] : ["impact", "review"]
);

export const activeCategories = (impact) => (impact?.categories || []).filter((category) => category.count > 0);

// the first allowed action is the default: transfer for owner items, transfer/unassign/detach otherwise
export function initialDecisions(impact) {
    return Object.fromEntries(activeCategories(impact).map((category) => [
        category.key,
        {action: category.actions[0], target: null},
    ]));
}

// one destination for everything that can be transferred
export function applyTargetToAll(impact, decisions, target) {
    const next = {...decisions};
    for (const category of activeCategories(impact)) {
        if (category.actions.includes("transfer")) next[category.key] = {action: "transfer", target};
    }
    return next;
}

// the first category whose decision is missing or incomplete, or null when all are ready
export function firstInvalidCategory(impact, decisions = {}) {
    return activeCategories(impact).find((category) => {
        const decision = decisions[category.key];
        if (!decision || !category.actions.includes(decision.action)) return true;
        return decision.action === "transfer" && !decision.target;
    })?.key || null;
}

export function offboardingPayload(impact, decisions, idempotencyKey) {
    return {
        idempotencyKey,
        fingerprint: impact?.fingerprint,
        decisions: Object.fromEntries(activeCategories(impact).map((category) => {
            const decision = decisions[category.key] || {};
            return [category.key, decision.action === "transfer"
                ? {action: "transfer", target: decision.target}
                : {action: decision.action}];
        })),
    };
}

// active members who can receive responsibilities: not the leaving member, not disabled/removed, not pending
export function destinationMembers(rows = [], leavingMembershipId) {
    return rows.filter((row) => row.rowType === "member"
        && String(row.membershipId) !== String(leavingMembershipId)
        && !["restricted", "removed"].includes(String(row.memberShipStatus || "")));
}

export function newIdempotencyKey() {
    if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") return crypto.randomUUID();
    return `off-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 12)}`;
}
